import { flattenDeep, get } from 'lodash'

import FORMATS from 'constants/formats'
import { isEmpty } from 'helpers/utils'

export const getFieldFromObject = (object, field) => get(object, field)

export const getCommonValues = (objects, field, unique) => {
  const mappedValues = objects?.map(item => getFieldFromObject(item, field))
  const filteredValues = mappedValues?.filter(value => !isEmpty(value))

  const uniqueValues = unique ? [...new Set(filteredValues)] : []

  return mapValuesToString(unique ? uniqueValues : filteredValues)
}

export const mapValuesToString = values => values?.join('|')

export const mapUniqValuesToString = values => [...new Set([...values])].join('|')

export const objectFieldsPassPredicate = (object, field, predicate) => {
  const value = getFieldFromObject(object, field)

  return predicate(value)
}

export const getCommonValuesByMappedField = (object, groupBy, mapBy, unique) => {
  const groups = getFieldFromObject(object, groupBy)

  return getCommonValues(flattenDeep(groups), mapBy, unique)
}

export const getCurrentUrl = () => {
  if (typeof window === 'undefined') {
    return ''
  }

  return `${location.origin}${location.pathname}`
}

export const getSelectedOffersByDate = (selectedDates, calendarOffers) => {
  const [outbound, inbound] = selectedDates
  const departureDate = outbound.format(FORMATS.YEAR_MONTH_NUMBER_DAY_NUMBER)
  const arrivalDate = inbound ? inbound.format(FORMATS.YEAR_MONTH_NUMBER_DAY_NUMBER) : null

  if (!isEmpty(calendarOffers)) {
    const { 0: outboundOffers, 1: inboundOffers } = calendarOffers
    const outboundOffer = outboundOffers.find(({ departure }) => departure === departureDate)
    const inboundOffer = inboundOffers
      ? inboundOffers.find(({ departure }) => departure === arrivalDate)
      : null

    return [outboundOffer, inboundOffer]
  }

  return [null, null]
}
